import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Newspaper } from "lucide-react";
import Seo from "@/lib/Seo";
import { api, mediaUrl, formatDate } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function Actualites() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api.get("/public/blog").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  return (
    <>
      <Seo title="Actualités" path="/actualites"
        description="Toute l'actualité de Douzième Homme — Le Jeu : nouveaux points de vente, événements, questions bonus et coulisses de fabrication." />
      <section className="py-14 sm:py-20" data-testid="blog-page">
        <div className="container-x">
          <Reveal className="max-w-3xl mb-12">
            <p className="eyebrow mb-4">Actualités</p>
            <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight uppercase leading-[1.05] text-onyx">
              Le vestiaire.
            </h1>
            <p className="mt-5 text-base sm:text-lg text-muted-foreground">
              Nouveautés, événements et coulisses de Douzième Homme — Le Jeu.
            </p>
          </Reveal>

          {posts === null ? (
            <p className="text-muted-foreground" data-testid="blog-loading">Chargement…</p>
          ) : posts.length === 0 ? (
            <div className="bg-white border border-line p-10 text-center" data-testid="blog-empty">
              <Newspaper className="w-8 h-8 text-rouge mx-auto mb-4" />
              <p className="font-display font-bold text-onyx text-lg">Les premières actualités arrivent très vite.</p>
              <p className="text-sm text-muted-foreground mt-2">Suivez-nous sur les réseaux pour ne rien manquer.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
              {posts.map((p, i) => (
                <Reveal key={p.id} delay={i * 0.06}>
                  <Link to={`/actualites/${p.slug}`} data-testid={`blog-card-${p.slug}`}
                    className="group block bg-white border border-line h-full hover:border-rouge/40 transition-colors">
                    {p.image && (
                      <div className="aspect-[16/10] overflow-hidden">
                        <img src={mediaUrl(p.image)} alt={p.title} loading="lazy"
                          className="w-full h-full object-contain group-hover:scale-[1.03] transition-transform duration-500" />
                      </div>
                    )}
                    <div className="p-6">
                      <p className="font-mono text-xs text-muted-foreground mb-2">{formatDate(p.published_at)}</p>
                      <h2 className="font-display font-bold text-xl leading-snug text-onyx group-hover:text-rouge transition-colors">{p.title}</h2>
                      {p.excerpt && <p className="text-sm text-muted-foreground mt-3 line-clamp-3">{p.excerpt}</p>}
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
